import React from 'react';

const Dashboard = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">Dashboard</h1>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <p className="text-gray-600 dark:text-gray-400">Welcome to the Wildlife Comforts admin panel.</p>
      </div>
    </div>
  );
};

export default Dashboard;